var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewReadabilityScores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "vrs_cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1792v1080h-1792z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.vrs_s0 { fill: #000000 } \n\t\t.vrs_s1 { fill: #d01b21 } \n\t\t.vrs_s2 { fill: #fdb12a } \n\t\t.vrs_s3 { fill: #309a2b } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-task-view-readability-scores",
    clipPath: "url(#vrs_cp1)",
    transform: "translate(-729 -314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7779vrs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12351vrs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 14262vrs",
    fillRule: "evenodd",
    className: "vrs_s0",
    d: "m731.6 317.1c0.9-1.3 2.3-2.2 4.3-2.2 2 0 3.5 0.9 4.4 2.2 0.9 1.4 1.3 3.2 1.3 5.2 0 1.9-0.4 3.7-1.3 5.1-0.9 1.4-2.4 2.3-4.4 2.3-2 0-3.4-0.9-4.3-2.3-1-1.4-1.3-3.2-1.3-5.1 0-2 0.3-3.8 1.3-5.2zm2.1 9.8c0.5 0.6 1.2 0.9 2.2 0.9 1 0 1.7-0.3 2.3-0.9 0.8-0.9 1.2-2.4 1.2-4.6 0-2.2-0.4-3.7-1.2-4.6-0.6-0.6-1.3-0.9-2.3-0.9-1 0-1.7 0.3-2.2 0.9-0.9 0.9-1.3 2.4-1.3 4.6 0 2.2 0.4 3.7 1.3 4.6zm11.1-0.4c0.9 0 1.6 0.6 1.6 1.5 0 0.8-0.7 1.5-1.6 1.5-0.8 0-1.5-0.7-1.5-1.5 0-0.9 0.7-1.5 1.5-1.5zm4-6.5q0-0.3 0-0.5c0-2.5 1.8-4.6 4.9-4.6 3.1 0 4.8 2 4.8 4.3 0 1.9-1 3.4-2.6 4.4l-2.9 1.8c-0.8 0.5-1.5 1.1-1.7 2h7.3v2h-9.9c0-2.3 0.9-4.1 3.3-5.7l2.4-1.5c1.3-0.9 2-1.9 2-3 0-1.3-0.9-2.5-2.7-2.5-1.9 0-2.8 1.3-2.8 3q0 0.3 0.1 0.6zm13-2.9c0.9-1.4 2.4-2.3 4.4-2.3 2 0 3.4 0.9 4.3 2.3 1 1.4 1.3 3.2 1.3 5.2 0 1.9-0.3 3.7-1.3 5.1-0.9 1.4-2.3 2.3-4.3 2.3-2 0-3.5-0.9-4.4-2.3-0.9-1.4-1.3-3.2-1.3-5.1 0-2 0.4-3.8 1.3-5.2zm2.1 9.8c0.6 0.5 1.3 0.9 2.3 0.9 1 0 1.7-0.4 2.2-0.9 0.9-0.9 1.3-2.5 1.3-4.6 0-2.2-0.4-3.8-1.3-4.7-0.5-0.5-1.2-0.9-2.2-0.9-1 0-1.7 0.4-2.3 0.9-0.8 0.9-1.2 2.5-1.2 4.7 0 2.1 0.4 3.7 1.2 4.6zm13.3-11.9c1.9 0 3.5 1.5 3.5 3.4 0 2-1.6 3.5-3.5 3.5-1.9 0-3.5-1.5-3.5-3.5 0-1.9 1.6-3.4 3.5-3.4zm-1.8 14.4l10.3-14.3h1.9l-10.1 14.3zm10.4-6.8c1.9 0 3.5 1.5 3.5 3.5 0 1.9-1.6 3.4-3.5 3.4-1.9 0-3.5-1.5-3.5-3.4 0-2 1.6-3.5 3.5-3.5zm0 5.2c1 0 1.7-0.7 1.7-1.7 0-1-0.7-1.7-1.7-1.7-0.9 0-1.7 0.7-1.7 1.7 0 1 0.8 1.7 1.7 1.7zm-8.7-7.6c1 0 1.7-0.8 1.7-1.8 0-1-0.7-1.7-1.7-1.7-0.9 0-1.7 0.7-1.7 1.7 0 1 0.8 1.8 1.7 1.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 12350vrs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 87vrs",
    className: "vrs_s1",
    d: "m758 354.8c-3.9 0-7-3.3-7-7.5 0-4.1 3.1-7.5 7-7.5 3.9 0 7 3.4 7 7.5 0 4.2-3.1 7.5-7 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 95vrs",
    className: "vrs_s2",
    d: "m737 354.8c-3.9 0-7-3.3-7-7.5 0-4.1 3.1-7.5 7-7.5 3.9 0 7 3.4 7 7.5 0 4.2-3.1 7.5-7 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 96vrs",
    className: "vrs_s3",
    d: "m778.5 354.8c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5 4.1 0 7.5 3.4 7.5 7.5 0 4.2-3.4 7.5-7.5 7.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReadabilityScores);
export default __webpack_public_path__ + "static/media/view-readability-scores.24b527a92dab85a84b5456b5ba5cb4d5.svg";
export { ForwardRef as ReactComponent };